import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { ProductsModel } from '../../models/Products';
import { Card } from './Card';

// 🎯 Interface Segregation Principle (ISP) - Mismas props que LocationTable
interface CardListProps {
  products: ProductsModel[];
  isLoading?: boolean;
  className?: string;
  // 🎯 Props para scroll infinito
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  // 🎯 Props para sorting - manejado desde el padre
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
  total?: number;
  // 🎯 Props específicas para cards
  // 🎯 Prop para estimación de altura cuando es dinámica
  estimateItemHeight?: number;
  onReservedClick?: (product: any) => void;
  onStockClick?: (product: any) => void;
  // 🎯 Prop para ocultar columnas seleccionadas
  selectedColumns?: string[];
}

export const CardList = ({
  products,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  estimateItemHeight = 120, // 🎯 Estimación conservadora para cards con productos
  onReservedClick,
  onStockClick,
  selectedColumns,
}: CardListProps) => {
  const { t } = useTranslation('productsModule');

  // 🎯 Render function que usa el componente LocationCard
  const renderLocationCard = (props: RenderItemProps<ProductsModel>) => (
    <Card
      product={props.item}
      onReservedClick={onReservedClick}
      onStockClick={onStockClick}
      selectedColumns={selectedColumns}
    />
  );

  // 🎯 Key generator para optimizar renders
  const getProductsKey = (products: ProductsModel) => {
    return products.id;
  };

  return (
    <VirtualList
      data={products}
      renderItem={renderLocationCard}
      itemKey={getProductsKey}
      // 🎯 Configuración optimizada para móvil con altura dinámica
      estimateItemHeight={estimateItemHeight} // 🎯 Solo estimación, altura real será medida
      height="calc(100vh - 150px)" // Altura completa en móvil
      gap={0} // Sin gap entre cards
      emptyMessage={t('empty.message')}
      className={`rounded-lg shadow-sm ${className}`}
      // 🎯 Props de scroll infinito
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300} // Threshold mayor para móvil
      // 🎯 Props de sorting (aunque en móvil se use menos)
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      // 🎯 Styling específico para móvil
      listClassName="touch-pan-y" // Mejor scroll en mobile
      itemClassName="touch-manipulation" // Optimización touch
    />
  );
};
